import { render, staticRenderFns } from "./EducationDescriptionTab.vue?vue&type=template&id=f02a9b76&scoped=true"
import script from "./EducationDescriptionTab.vue?vue&type=script&lang=js"
export * from "./EducationDescriptionTab.vue?vue&type=script&lang=js"
import style0 from "./EducationDescriptionTab.vue?vue&type=style&index=0&id=f02a9b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02a9b76",
  null
  
)

export default component.exports